import {createAction, props} from "@ngrx/store";

const TYPE = '[Session]';

export const GetSession = createAction(`${TYPE} Get Session`);
export const SetSession = createAction(`${TYPE} Set Session`, props<{sess: any}>());
export const LoadingSession = createAction(`${TYPE} Loading Session`);
export const ResetSession = createAction(`${TYPE} Reset Session`);
